import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';
import { userObj } from "../../../../../helper/protectedRoutes";
import baseUrl from '../../../../../helper/api';

const initialState = {
    vehicleSizeData:[],
    vehicleSizeIsLoading:false,
    status:null,
}

const token = userObj?.token

export const vehicleSizes = createAsyncThunk(
    'partner/vehicleSizes',
    async (_, {rejectWithValue}) => {
        
        try{
            const response = await axios.get(`${baseUrl}/Settings/vehicleSizes`,
            {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }
            )
            return response?.data
        } catch (err) {
            return rejectWithValue(err.response.data.title)
        }
        
    }
)


const vehicleSizesSlice = createSlice({
    name: 'vehicleSizes',
    initialState,
    reducers: {},
    extraReducers:{
        [vehicleSizes.pending]: (state, action) => {
            state.status='pending';
            state.vehicleSizeIsLoading=true;
        },
        [vehicleSizes.fulfilled]: (state, action) => {
            state.status='success';
            state.vehicleSizeIsLoading=false;
            state.vehicleSizeData = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
    
        [vehicleSizes.rejected]: (state, action) => {
            state.status='failed';
            state.vehicleSizeIsLoading=false;
        }
    }
})

export default vehicleSizesSlice.reducer;